import { render, staticRenderFns } from "./SettingsMainImage.vue?vue&type=template&id=0ef69706&"
import script from "./SettingsMainImage.vue?vue&type=script&lang=js&"
export * from "./SettingsMainImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports